import {
  Box,
  Flex,
  Grid,
  Image,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tr,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { useColorMode } from "@chakra-ui/react";

const showLitioConValue = (results) => {
  if(results['no_show'])
      return "Não é possível calcular eLi12 h pois o tempo decorrido dentre a ingesta até a coleta está fora da faixa de 3 a 24 h";

  return `${results.eLi12.toFixed(2)} mEq/L`;
}

const CustomerKitResult = ({ results, kitTypeId }) => {
  const { colorMode } = useColorMode();
  const textColor = colorMode == "light" ? "black" : "white";

  return (
    <Flex w="100%" direction="column" mb="20px" pt="20px">
      <Text color={textColor} fontSize="lg" fontWeight="bold" mb="10px">
        Resultado Exame
      </Text>
      <TableContainer>
        <Table
          variant="striped"
          size="md"
          width="full"
        >
          <Tbody>
            {kitTypeId !== 7 ? (
              <>
                <Text>Colesterol Total: {results.colesterol_total}</Text>
                <Text>Colesterol HDL: {results.hdl}</Text>
                <Text>Colesterol LDL: {results.ldl}</Text>
                <Text>Glicose: {results.glicose}</Text>
                <Text>Hemoglobina HBA1C: {results.hba1c}</Text>
              </>
            ) : (
              <>
                <Tr><Td>Concentração sérica de Lítio:</Td></Tr>
                <Tr><Td>{results.value} mEq/L</Td></Tr>
                <Tr><Td>Cálculo concentração de lítio 12 h:</Td></Tr>
                <Tr><Td>{showLitioConValue(results)}</Td></Tr>
              </>
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </Flex>
  );
};

export default CustomerKitResult;
